import * as actionTypes from "../ActionTypes/index";

// Plan Actions (existing)
export const savePlanRequest = (payload, callback) => {
    return {
    type: actionTypes.SAVE_PLAN_REQUEST,
    payload,
    callback,
  };
};

export const savePlanSuccess = (data) => ({ type: actionTypes.SAVE_PLAN_SUCCESS, payload: data });
export const savePlanFailure = (error) => ({ type: actionTypes.SAVE_PLAN_FAILURE, payload: error });

export const updatePlanRequest = (payload, callback) => ({
  type: actionTypes.UPDATE_PLAN_REQUEST,
  payload,
  callback,
});
export const updatePlanSuccess = (data) => ({ type: actionTypes.UPDATE_PLAN_SUCCESS, payload: data });
export const updatePlanFailure = (error) => ({ type: actionTypes.UPDATE_PLAN_FAILURE, payload: error });

export const deletePlanRequest = (payload, callback) => ({
  type: actionTypes.DELETE_PLAN_REQUEST,
  payload,
  callback,
});
export const deletePlanSuccess = (data) => ({ type: actionTypes.DELETE_PLAN_SUCCESS, payload: data });
export const deletePlanFailure = (error) => ({ type: actionTypes.DELETE_PLAN_FAILURE, payload: error });

export const readPlanRequest = (payload, callback) => ({
  type: actionTypes.READ_PLAN_REQUEST,
  payload,
  callback,
});
export const readPlanSuccess = (data) => ({ type: actionTypes.READ_PLAN_SUCCESS, payload: data });
export const readPlanFailure = (error) => ({ type: actionTypes.READ_PLAN_FAILURE, payload: error });

export const readPlanCategoriesRequest = (payload, callback) => ({
  type: actionTypes.READ_PLAN_CATEGORIES_REQUEST,
  payload,
  callback,
});
export const readPlanCategoriesSuccess = (data) => ({ type: actionTypes.READ_PLAN_CATEGORIES_SUCCESS, payload: data });
export const readPlanCategoriesFailure = (error) => ({ type: actionTypes.READ_PLAN_CATEGORIES_FAILURE, payload: error });

export const savePlanCategoryRequest = (payload, callback) => ({
  type: actionTypes.SAVE_PLAN_CATEGORY_REQUEST,
  payload,
  callback,
});
export const savePlanCategorySuccess = (data) => ({ type: actionTypes.SAVE_PLAN_CATEGORY_SUCCESS, payload: data });
export const savePlanCategoryFailure = (error) => ({ type: actionTypes.SAVE_PLAN_CATEGORY_FAILURE, payload: error });

// Day Plan Actions (updated with detail actions)
export const saveDayPlanRequest = (payload, callback) => {
    return {
    type: actionTypes.SAVE_DAYPLAN_REQUEST,
    payload,
    callback,
  };
};
export const saveDayPlanSuccess = (data) => ({ type: actionTypes.SAVE_DAYPLAN_SUCCESS, payload: data });
export const saveDayPlanFailure = (error) => ({ type: actionTypes.SAVE_DAYPLAN_FAILURE, payload: error });

export const updateDayPlanRequest = (payload, callback) => ({
  type: actionTypes.UPDATE_DAYPLAN_REQUEST,
  payload,
  callback,
});
export const updateDayPlanSuccess = (data) => ({ type: actionTypes.UPDATE_DAYPLAN_SUCCESS, payload: data });
export const updateDayPlanFailure = (error) => ({ type: actionTypes.UPDATE_DAYPLAN_FAILURE, payload: error });

export const deleteDayPlanRequest = (payload, callback) => ({
  type: actionTypes.DELETE_DAYPLAN_REQUEST,
  payload,
  callback,
});
export const deleteDayPlanSuccess = (data) => ({ type: actionTypes.DELETE_DAYPLAN_SUCCESS, payload: data });
export const deleteDayPlanFailure = (error) => ({ type: actionTypes.DELETE_DAYPLAN_FAILURE, payload: error });

export const readDayPlanRequest = (payload, callback) => ({
  type: actionTypes.READ_DAYPLAN_REQUEST,
  payload,
  callback,
});
export const readDayPlanSuccess = (data) => ({ type: actionTypes.READ_DAYPLAN_SUCCESS, payload: data });
export const readDayPlanFailure = (error) => ({ type: actionTypes.READ_DAYPLAN_FAILURE, payload: error });

// Day Plan Detail Actions (NEW)
export const saveDayPlanDetailRequest = (payload, callback) => {
    return {
    type: actionTypes.SAVE_DAYPLAN_DETAIL_REQUEST,
    payload,
    callback,
  };
};
export const saveDayPlanDetailSuccess = (data) => ({ type: actionTypes.SAVE_DAYPLAN_DETAIL_SUCCESS, payload: data });
export const saveDayPlanDetailFailure = (error) => ({ type: actionTypes.SAVE_DAYPLAN_DETAIL_FAILURE, payload: error });

export const updateDayPlanDetailRequest = (payload, callback) => ({
  type: actionTypes.UPDATE_DAYPLAN_DETAIL_REQUEST,
  payload,
  callback,
});
export const updateDayPlanDetailSuccess = (data) => ({ type: actionTypes.UPDATE_DAYPLAN_DETAIL_SUCCESS, payload: data });
export const updateDayPlanDetailFailure = (error) => ({ type: actionTypes.UPDATE_DAYPLAN_DETAIL_FAILURE, payload: error });

// Add these action creators
export const deleteDayPlanDetailRequest = (payload, callback) => ({
  type: actionTypes.DELETE_DAYPLAN_DETAIL_REQUEST,
  payload,
  callback,
});
export const deleteDayPlanDetailSuccess = (data) => ({
  type: actionTypes.DELETE_DAYPLAN_DETAIL_SUCCESS,
  payload: data
});
export const deleteDayPlanDetailFailure = (error) => ({
  type: actionTypes.DELETE_DAYPLAN_DETAIL_FAILURE,
  payload: error
});

// TWG Plans Actions
export const readTWGPlansRequest = (payload, callback) => ({
  type: actionTypes.READ_TWG_PLANS_REQUEST,
  payload,
  callback,
});
export const readTWGPlansSuccess = (data) => ({ type: actionTypes.READ_TWG_PLANS_SUCCESS, payload: data });
export const readTWGPlansFailure = (error) => ({ type: actionTypes.READ_TWG_PLANS_FAILURE, payload: error });

// Plan Link Actions
export const savePlanLinkRequest = (payload, callback) => ({
  type: actionTypes.SAVE_PLANLINK_REQUEST,
  payload,
  callback,
});
export const savePlanLinkSuccess = (data) => ({ type: actionTypes.SAVE_PLANLINK_SUCCESS, payload: data });
export const savePlanLinkFailure = (error) => ({ type: actionTypes.SAVE_PLANLINK_FAILURE, payload: error });

export const updatePlanLinkRequest = (payload, callback) => ({
  type: actionTypes.UPDATE_PLANLINK_REQUEST,
  payload,
  callback,
});
export const updatePlanLinkSuccess = (data) => ({ type: actionTypes.UPDATE_PLANLINK_SUCCESS, payload: data });
export const updatePlanLinkFailure = (error) => ({ type: actionTypes.UPDATE_PLANLINK_FAILURE, payload: error });

export const deletePlanLinkRequest = (payload, callback) => ({
  type: actionTypes.DELETE_PLANLINK_REQUEST,
  payload,
  callback,
});
export const deletePlanLinkSuccess = (data) => ({ type: actionTypes.DELETE_PLANLINK_SUCCESS, payload: data });
export const deletePlanLinkFailure = (error) => ({ type: actionTypes.DELETE_PLANLINK_FAILURE, payload: error });

export const readPlanLinkRequest = (payload, callback) => ({
  type: actionTypes.READ_PLANLINK_REQUEST,
  payload,
  callback,
});
export const readPlanLinkSuccess = (data) => ({ type: actionTypes.READ_PLANLINK_SUCCESS, payload: data });
export const readPlanLinkFailure = (error) => ({ type: actionTypes.READ_PLANLINK_FAILURE, payload: error });
